
// firebase.js
import { initializeApp } from "firebase/app"
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getStorage } from 'firebase/storage'
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyBXyiQvkxUZM-umduUiqHkeVFFsMsCmPP8",
    authDomain: "restaurant-56c7a.firebaseapp.com",
    projectId: "restaurant-56c7a",
    storageBucket: "restaurant-56c7a.firebasestorage.app",
    messagingSenderId: "351317600052",
    appId: "1:351317600052:web:b8d771964dd244cc3d6761",
    measurementId: "G-KQNZJ8BLZ9"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Firestore
const db = getFirestore(app)

// Auth
const auth = getAuth(app)

// Storage
const storage = getStorage(app)

const functions = getFunctions(app, "us-central1");

export { db, auth, storage, functions }
